import { Module } from 'vuex'
import { getters } from './getters'
import { actions } from './actions'
import { mutations } from './mutations'
import { SimpleStoreState } from './types'
import { RootState } from '../../types'

export const state: SimpleStoreState = {
  products: null
}

const namespaced = true

export const simpleStore: Module<SimpleStoreState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
